import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
export function CTASection() {
  return <Section id="cta" className="bg-navy-900 pb-32" dark={true} data-id="element-16">
      <div className="max-w-4xl mx-auto bg-gradient-to-b from-navy-800 to-navy-900 rounded-3xl p-8 md:p-16 text-center border border-navy-700 shadow-2xl relative overflow-hidden" data-id="element-17">
        {/* Glow effect */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-lg bg-gold-500/5 blur-3xl rounded-full pointer-events-none" data-id="element-18" />

        <div className="relative z-10 space-y-8" data-id="element-19">
          <h2 className="text-3xl md:text-4xl font-serif text-cream-50" data-id="element-20">
            Get the blueprint today
          </h2>

          <div className="space-y-2" data-id="element-21">
            <h3 className="text-2xl md:text-3xl font-serif text-gold-400" data-id="element-22">
              The Sleep & Serenity Blueprint
            </h3>
            <p className="text-lg text-cream-100/60 uppercase tracking-widest" data-id="element-23">
              For Women 40+
            </p>
          </div>

          <div className="py-4" data-id="element-24">
            <div className="flex items-center justify-center gap-4 mb-2" data-id="element-25">
              <span className="text-2xl md:text-3xl font-serif text-cream-100/40 line-through" data-id="element-26">
                $29
              </span>
              <span className="bg-gold-500 text-navy-900 px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wide" data-id="element-27">
                60% OFF
              </span>
            </div>
            <div className="text-5xl md:text-6xl font-serif text-cream-50 font-bold" data-id="element-28">
              $6.39
            </div>
          </div>

          <div className="max-w-md mx-auto" data-id="element-29">
            <Button href="https://www.mellowreset.com/cart/42935503323202:1" fullWidth className="text-xl py-6 shadow-gold-500/20 shadow-xl" data-id="element-30">
              Get The Blueprint Now
            </Button>
            <p className="mt-6 text-sm text-cream-100/50" data-id="element-31">
              Secure payment • Instant digital download
            </p>
          </div>

          <p className="text-lg text-cream-100/80 pt-8 border-t border-navy-700/50 max-w-lg mx-auto" data-id="element-32">
            You don't need a perfect night. <br data-id="element-33" />
            You need a repeatable close to the day.
          </p>
        </div>
      </div>
    </Section>;
}